import type { FormGroupProps } from '@ksyos/design-system/dist/components/form-group';
import { FormGroup } from '@ksyos/design-system';
import type { FormContextProps } from '../elements/formContext';
import { translateKey } from '../../translate';
import { FormContextConsumer } from '../elements/formContext';

export type IFormGroupFieldProps = Omit<FormGroupProps, 'children'>;

export interface IFormGroupFieldExtraProps {
    noTranslationForLabel?: boolean;
}

export function FormGroupField(props: FormContextProps<FormGroupProps> & IFormGroupFieldExtraProps) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => (
                <FormGroup
                    hasErrors={properties.hasErrors}
                    htmlFor={props.htmlFor}
                    isRequired={properties.isRequired}
                    label={getLabel(properties.label, props.noTranslationForLabel)}
                    layout={properties.layout}
                    tooltipText={properties.tooltipText}
                >
                    {props.children}
                </FormGroup>
            )}
        </FormContextConsumer>
    );
}

function getLabel(label?: string, noTranslationForLabel?: boolean) {
    if (!label) {
        return '';
    }

    return noTranslationForLabel ? label : translateKey(label);
}
